import React, { Component } from 'react';
import {firebaseAuth, ref } from '../config/constants'
import {formatPrice,formatQuantity} from '../helpers/helpers'
import moment from 'moment'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';
import PrintOrder from './PrintOrder'

class PurchaseOrderView extends Component {

    
    
    render() {
            
            
        return (                        
                <div>
                    <div id="react-no-print">   
                        <table className="table table-bordered table-striped ">
                            <thead>
                                <tr>               
                                    <th className="text-center" colSpan="2">Order Information</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="reviewQt">
                                    <td>Quotation Number : <span className="rvwQtData">{this.props.order.quoteNumber}</span></td>
                                </tr>
                                <tr className="reviewQt">
                                    <td>Customer Name : <span className="rvwQtData">{this.props.order.name}</span></td>
                                    <td>Address : <span className="rvwQtData">{this.props.order.address}</span></td>
                                </tr>
                                <tr className="reviewQt">
                                    <td>Item: <span className="rvwQtData">{this.props.order.item}</span></td>
                                    <td>Thickness : <span className="rvwQtData">{this.props.order.thickness}</span></td>
                                </tr>
                                <tr className="reviewQt">
                                    <td>Color : <span className="rvwQtData">{this.props.order.color}</span></td>
                                    <td>Date : <span className="rvwQtData">{this.props.order.date}</span></td>
                                </tr>
                            </tbody>
                        </table>
                        <table id="ecom-products" className="table table-bordered table-striped ">
                            <thead>
                                <tr>
                                    <th>Quantity</th>
                                    <th>Of Sheets</th>
                                    <th>Length</th>
                                    <th>Unit</th>
                                    <th>Total</th>
                                </tr>
                             </thead>
                             <tbody>
                                {
                                    this.props.orderLm &&
                                        Object.keys(this.props.orderLm).map(function (key){
                                            let list = this.props.orderLm[key]

                                            return(
                                                    <tr>
                                                        <td>{formatQuantity(list.number)}</td>
                                                        <td>Sheets</td>
                                                        <td>{formatQuantity(list.length)}</td>
                                                        <td>M</td>
                                                        <td>{formatQuantity(list.total)}</td>
                                                    </tr>
                                                )

                                        }.bind(this))
                                }
                                <tr>
                                    <td></td>
                                    <td></td>
                                    <td></td>
                                    <td>Grand Total</td>
                                    <td>{formatQuantity(this.props.order.totalLm)}</td>
                                </tr>
                             </tbody>   
                        </table>
                        <table id="ecom-products1" className="table table-bordered table-striped ">
                            <thead>
                                <tr>
                                    <th>Quantity</th>
                                    <th>Of Sheets</th>
                                    <th>Thickness</th>
                                    <th>Dimension</th>
                                    <th>Length</th>
                                    <th>Color</th>
                                </tr>
                            </thead>
                            {
                                    this.props.orderSheets &&
                                        Object.keys(this.props.orderSheets).map(function (key){
                                            let list = this.props.orderSheets[key]

                                            return(
                                                    <tr>
                                                        <td>{formatQuantity(list.number)}</td>
                                                        <td>Sheets</td>
                                                        <td>{list.thickness}</td>
                                                        <td>{list.dimension}</td>
                                                        <td>{list.length}</td>
                                                        <td>{list.color}</td>
                                                    </tr>
                                                )

                                        }.bind(this))
                                }
                               
                        </table>
                        <div className="submitContract text-center">
                            <button type="button" className="btn btn-primary pull-right" onClick={()=>window.print()}><i className="fa fa-print"></i> Print</button>
                        </div>
                    </div>            
                    <div>
                        <PrintOrder order={this.props.order} orderLm={this.props.orderLm} orderSheets={this.props.orderSheets}/>
                    </div>
                </div>                     
             
        );
    }
}

export default PurchaseOrderView;



// WEBPACK FOOTER //
// ./src/components/PurchaseOrderView.js